import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 8 — Expense Management shell. Sidebar nav + <Outlet/>, reusing the
 * shared `hr-shell` layout (mirrors PayrollGlobalShell). Additive module.
 */

const NAV = [
  { to: '/expenses/reports', label: 'My Reports', testid: 'expenses-nav-reports' },
  { to: '/expenses/approvals', label: 'Approvals', testid: 'expenses-nav-approvals' },
  { to: '/expenses/cards', label: 'Cards', testid: 'expenses-nav-cards' },
  { to: '/expenses/policies', label: 'Policies', testid: 'expenses-nav-policies' },
];

export default function ExpenseShell() {
  return (
    <div className="hr-shell" data-testid="expenses-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Expenses</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
